import { memo, useContext } from 'react'
import { connect, useSelector } from 'react-redux'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { path } from 'ramda'
import { colors } from '@/styles'
import { SupportChat } from '@/components/icons'
import { Input } from '@/components/form'
import { select } from '@/store'
import Tooltip from '@/components/custom-tooltip'
import { ChatContext } from '@/features/Chat/chat-side-bar/chat-context'
import useSearchParams, { stringifySearchParams } from '@/hooks/use-search-params'

const SupportChatContainer = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease-in-out;

  :hover {
    opacity: 0.7;
  }
`

const SupportChatIconContainer = styled.div`
  position: relative;
`

const SupportText = styled.span`
  font-size: 10px;
  color: ${colors.grey48};
  line-height: 0;
  padding: 5px 0;
`

const SupportChatUnread = styled.div`
  display: flex;
  width: 12px;
  height: 12px;
  font-size: 10px;
  position: absolute;
  top: 0;
  right: 0;
  color: ${colors.white};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: ${colors.blue64};
  border: 1px solid ${colors.white};
`

const SupportChatIcon = styled(SupportChat)`
  width: 33px;
  height: 33px;
`
const CheckBox = styled(Input)``

const mapState = state => ({
  support_room: select.supportRoom.roomInfo(state)
})

const SupportChatButton = ({
  history,
  selectMode,
  currentData,
  selectedChat,
  setSelectedChat,
  isCheckAll,
  setIsCheckAll,
  maxCount
}) => {
  const params = useSearchParams()
  const supportRoom = useSelector(path(['supportRoom', 'room_info']))
  const isRead = supportRoom?.last_user_read_at >= supportRoom?.updated_at
  const { getPath } = useContext(ChatContext)
  const { t } = useTranslation()
  const filtered = []

  const handleAllCheckBoxes = e => {
    setIsCheckAll(!isCheckAll)
    currentData.some((item, index) => {
      if (index < maxCount) {
        filtered.push(item.timeline_room)
        return
      }
      return
    })

    setSelectedChat(filtered)
    if (isCheckAll) {
      setSelectedChat([])
    }
  }

  return (
    <SupportChatContainer>
      {selectMode ? (
        <>
          <Tooltip text={t('l.contract.edit.select_all.label', 'Select All')} placement="right">
            <CheckBox onChange={handleAllCheckBoxes} type="checkbox" checked={isCheckAll} />
          </Tooltip>
        </>
      ) : (
        <>
          <SupportChatIconContainer
            onClick={() =>
              history.replace({
                pathname: getPath('support-room'),
                search: stringifySearchParams(params),
                state: {
                  from: getPath('timeline-room').replace(`/chat/${'support-room'}`, '/chat')
                }
              })
            }
          >
            {!isRead && <SupportChatUnread />}
            <SupportChatIcon />
          </SupportChatIconContainer>
          <SupportText>{t('b.sidebar.view.support.link', 'Support')}</SupportText>
        </>
      )}
    </SupportChatContainer>
  )
}

SupportChatButton.defaultProps = {
  timeline: {},
  url: '',
  name: '',
  unit: '',
  last_read: '',
  last_event: ''
}

export default connect(mapState)(memo(SupportChatButton))
